import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PasswordExpiryComponent } from './prompt/password-expiry.component'
import { AbleLoadingComponent } from './loading/able-loading.component';
import { SharedService } from './shared.service';
import { AbleDropdownComponent } from './dropdown/able-dropdown.component';
import { PerfectScrollbarDirective } from './directives/perfect-scrollbar.directive';
import { HttpClientModule } from '@angular/common/http';
import { BackgroundComponent, FooterComponent } from './layout';
import { SanitizeHtmlPipe } from './pipes/SanitizeHtml.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    AbleLoadingComponent,
    PasswordExpiryComponent,
    AbleDropdownComponent,
    PerfectScrollbarDirective,
    BackgroundComponent,
    FooterComponent,
    SanitizeHtmlPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    BackgroundComponent,
    FooterComponent,
    ReactiveFormsModule,
    HttpClientModule,
    AbleDropdownComponent,
    RouterModule,
    AbleLoadingComponent,
    PasswordExpiryComponent,
    PerfectScrollbarDirective
  ],
  providers: [
    SharedService,
    SanitizeHtmlPipe
  ]
})

export class SharedModule {}
